
let _vivo = {

    //加载基础代码
    load: function(){
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://sspstatic.vivo.com.cn/ssp/js/vadevent.1.0.0.js';

        let _head = document.getElementsByTagName("head")[0];
        _head.appendChild(script);
    },

    //加载事件代码
    submit: function () {
        try {
            VAD_EVENT.sendAction('submit', {act:'submit', name:'表单组件'});
        } catch (e) {
            console.log(e)
        }
    },
};

export default _vivo
